export const ApplicationOpened = 'ApplicationOpened'
// Auth
export const MainPasswordLogin = 'Main Password Login'
export const InstantLogin = 'Instant Login'
export const DontHaveAnAccount = `Don't Have an Account`
export const ApplyNowForFree = 'Apply Now for Free'
export const ForgotPassword = 'Forgot Password'
export const LoginInitiated = 'Login Initiated'
export const InstantLoginSMS = 'Instant Login SMS'
export const InstantLoginEmail = 'Instant Login Email'
export const SendLoginLinkSMS = 'Send Login Link SMS'
export const SendLoginLinkEmail = 'Send Login Link Email'
export const MagicLinkEmailBack = 'Magic Link Email Back'
export const MagicLinkSMSBack = 'Magic Link SMS Back'
export const ForgotPasswordSubmit = 'Forgot Password Submit'
export const ForgotPasswordBack = 'Forgot Password Back'
export const LoginSuccess = 'Login Success'
// Shifts
export const ShiftListLoaded = 'Shift List Loaded'
export const ShiftListFiltered = 'Shift List Filtered'
export const ShiftSelectedFromShifts = 'Shift Selected From Shifts'
export const ShiftSelectedFromMyShifts = 'Shift Selected From My Shifts'
// TODO DEFINE EVENT
export const ShiftSelectedFromNotifications =
  'Shift Selected From Notifications'
export const ShiftPostedFromTemplate = 'Shift Posted From Template'
export const ShiftPostedFromTemplateError = 'Shift Posted From Template Error'
export const ShiftPostedFromTemplateNavbar = 'Shift Posted From Template Navbar'
export const ShiftPostedFromTemplateNavbarError =
  'Shift Posted From Template Navbar Error'
export const ShiftPostedFromDuplicateModal = 'Shift Posted From Copy'
export const ShiftPostedFromDuplicateModalError = 'Shift Posted From Copy Error'
export const ShiftPostedFromDraft = 'Shift Posted From Draft'
export const ShiftPostedFromDraftError = 'Shift Posted From Draft Error'
export const ShiftPostedFromFullEditDraft = 'Shift Posted From Full Edit Draft'
export const ShiftPostedFromFullEditDraftError =
  'Shift Posted From Full Edit Draft Error'
export const ShiftPostedFromFullEdit = 'Shift Posted From Full Edit'
export const ShiftPostedFromFullEditError = 'Shift Posted From Full Edit Error'
// TODO DEFINE EVENT
export const ShiftListCleared = 'Shift List Cleared'
export const ShiftListLocationFilterProvided =
  'Shift List Location Filter Provided'
export const ShiftListSorted = 'Shift List Location Filter Sorted'
export const ShiftShareInitiated = 'Shift Share Initiated'
export const ShiftShareLinkSaved = 'Shift Share Link Saved'
export const ShiftOpened = 'Shift Opened'
// Favorite
export const FavoriteShiftInitiated = 'Favorite Shift Initiated'
export const UnfavoriteShiftInitiated = 'Unfavorite Shift Initiated'
export const FavoriteShiftAdded = 'Favorite Shift Added'
// Applications
export const ShiftApplicationInitiated = 'Shift Application initiated'
// TODO DEFINE EVENT
export const ShiftApplicationStarted = 'Shift Application Started '
export const ShiftApplicationStatedWithAcknowledgedDocuments =
  'Shift Application Started Acknowledged Documents'
export const ShiftApplicationStatedWithBackgroundCheck =
  'Shift Application Started Background Check'
export const ShiftApplicationStatedWithBackgroundCheckAndFACIS =
  'Shift Application Started Background Check And Facis'
export const ShiftApplicationStatedWithDrugTest =
  'Shift Application Started Drug Test'
export const ShiftApplicationCancelled = 'Shift Application Cancelled'
export const ShiftApplicationAutoAccept = 'Shift Application Auto_accept'
export const ShiftApplicationConfirmed = 'Shift Application Confirmed'
// Clock In
export const ShiftClockIn = 'Shift Clock In'
export const ShiftClockOut = 'Shift Clock Out'
// Shift Main Filters
export const ShiftsFilterSubmit = 'Shifts Filter Submit'
export const ShiftsFilterReset = 'Shifts Filter Reset'

export interface IEvents {
  [key: string]: string
}

export const Events: IEvents = {
  ApplicationOpened,
  LoginInitiated,
  InstantLoginSMS,
  InstantLoginEmail,
  SendLoginLinkSMS,
  SendLoginLinkEmail,
  MagicLinkEmailBack,
  MagicLinkSMSBack,
  MainPasswordLogin,
  InstantLogin,
  DontHaveAnAccount,
  ApplyNowForFree,
  ForgotPassword,
  ForgotPasswordSubmit,
  ForgotPasswordBack,
  LoginSuccess,
  ShiftListLoaded,
  ShiftListFiltered,
  ShiftListCleared,
  ShiftListLocationFilterProvided,
  ShiftListSorted,
  ShiftShareInitiated,
  ShiftShareLinkSaved,
  ShiftOpened,
  ShiftSelectedFromShifts,
  ShiftSelectedFromMyShifts,
  ShiftSelectedFromNotifications,
  FavoriteShiftInitiated,
  UnfavoriteShiftInitiated,
  FavoriteShiftAdded,
  ShiftApplicationInitiated,
  ShiftApplicationStarted,
  ShiftApplicationStatedWithAcknowledgedDocuments,
  ShiftApplicationStatedWithBackgroundCheck,
  ShiftApplicationStatedWithBackgroundCheckAndFACIS,
  ShiftApplicationStatedWithDrugTest,
  ShiftApplicationCancelled,
  ShiftApplicationAutoAccept,
  ShiftApplicationConfirmed,
  ShiftClockIn,
  ShiftClockOut,
  ShiftPostedFromTemplate,
  ShiftPostedFromTemplateError,
  ShiftPostedFromTemplateNavbar,
  ShiftPostedFromTemplateNavbarError,
  ShiftPostedFromDuplicateModal,
  ShiftPostedFromDuplicateModalError,
  ShiftPostedFromDraft,
  ShiftPostedFromDraftError,
  ShiftPostedFromFullEditDraft,
  ShiftPostedFromFullEditDraftError,
  ShiftPostedFromFullEdit,
  ShiftPostedFromFullEditError,
  ShiftsFilterSubmit,
  ShiftsFilterReset,
}
